export const CONFLICT = "Conflict";
export const GIFT = "Gift";


// WEBPACK FOOTER //
// ./app/constants/disclosureType.js